import React from 'react';
import PropTypes from 'prop-types';

export const Paragraph = ({ className, children }) => (
  <p className={`sui-pb-2 sui-pt-2 sui-text-sm ${className}`}>{children}</p>
);

Paragraph.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Paragraph.defaultProps = {
  className: '',
};
